import React, { useRef } from 'react';
import classnames from 'classnames';
import { ReviewItemPropType } from '../reviews/PropTypes';
import useObserver from '../shared/hooks/useObserver';
import { reportSingleReviewMixpanelEvent } from '../shared/hoc/withImpressionReviews/reportSingleReviewMixpanelEvent';
import { SingleReviewFooter } from './SingleReviewFooter';

import styles from './styles.module.scss';

export const SingleReview = ({ review }) => {
    const reviewsRef = useRef(null);
    const { comment: text, reviewer_country_code: countryCode, user_image_url: userImageUrl, username, value } = review;

    useObserver({
        observableRef: reviewsRef,
        onObserve: () => reportSingleReviewMixpanelEvent(username),
    });

    const user = {
        has_profile_photo: !!userImageUrl,
        username,
        profile_photo: userImageUrl,
    };

    return (
        <div className={styles.singleReview}>
            <p className={classnames('flex tbody-5 co-grey-1000', styles.text)}>
                <span className={styles.content}>“{text}</span>
                <span className={styles.endQuete}>”</span>
            </p>
            <SingleReviewFooter user={user} countryCode={countryCode} value={value} />
        </div>
    );
};

SingleReview.propTypes = {
    review: ReviewItemPropType,
};
